import { IconProps } from 'components/Shared/Icon';
import { iconStyles } from 'components/Shared/Icon/iconStyles';

// tslint:disable: max-line-length
export const IconFavourite = (props: IconProps) => (
  <svg
    className={iconStyles(props)}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0273 0.380371C13.2873 0.380371 11.6173 1.23745 10.5273 2.59183C9.43734 1.23745 7.76734 0.380371 6.02734 0.380371C2.94734 0.380371 0.527344 2.94101 0.527344 6.20001C0.527344 10.1997 3.92734 13.4587 9.07734 18.4107L10.5273 19.7968L11.9773 18.4001C17.1273 13.4587 20.5273 10.1997 20.5273 6.20001C20.5273 2.94101 18.1073 0.380371 15.0273 0.380371ZM10.6273 16.8341L10.5273 16.9399L10.4273 16.8341C5.66734 12.2736 2.52734 9.25797 2.52734 6.20001C2.52734 4.08378 4.02734 2.4966 6.02734 2.4966C7.56734 2.4966 9.06734 3.54414 9.59734 4.99376H11.4673C11.9873 3.54414 13.4873 2.4966 15.0273 2.4966C17.0273 2.4966 18.5273 4.08378 18.5273 6.20001C18.5273 9.25797 15.3873 12.2736 10.6273 16.8341Z"
      stroke="none"
    />
  </svg>
);
